<template>
  <form>
    <md-card data-tour="advanced_video_codec_config">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>videocam</md-icon>
        </div>
        <h4 class="title">
          Video Codecs
        </h4>
        <help-link :link="helpLink.link" title="video-codec"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-switch v-model="vp8State" data-tour="channel_vp8">
              VP8
            </md-switch>
            <md-field>
              <label>Max Bitrate (kbps)</label>
              <md-input
                :disabled="!vp8State"
                v-model="channel.codec.vp8.bitrate"
                v-on:blur="validateChannel($v.channel.codec.vp8.bitrate)"
                type="number"
                class="full-width"
                data-tour="channel_vp8_bitrate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-switch v-model="vp9State" data-tour="vp9">
              VP9
            </md-switch>
            <md-field>
              <label>Max Bitrate (kbps)</label>
              <md-input
                :disabled="!vp9State"
                v-model="channel.codec.vp9.bitrate"
                v-on:blur="validateChannel($v.channel.codec.vp9.bitrate)"
                type="number"
                class="full-width"
                data-tour="channel_vp9_bitrate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-switch v-model="h264State" data-tour="channel_h264">
              H.264
            </md-switch>
            <md-field>
              <label>Max Bitrate (kbps)</label>
              <md-input
                :disabled="!h264State"
                v-model="channel.codec.h264.bitrate"
                v-on:blur="validateChannel($v.channel.codec.h264.bitrate)"
                type="number"
                class="full-width"
                data-tour="channel_h264_bitrate"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js';
import validationRules from '../../validationRules';
export default {
  props: {
    channel: null,
    ogChannel: null,
    headerColor: {
      type: String,
      default: ""
    }
  },
  components: {
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    helpLink: helpLinks.channelConfig.videoCodecs
  }),
  validations () {
    return validationRules;
  },
  computed: {
    vp8State: {
      get: function() {
        return !this.channel.codec.vp8.disabled;
      },
      set: function(state) {
        this.channel.codec.vp8.disabled = !state;
      }
    },
    vp9State: {
      get: function() {
        return !this.channel.codec.vp9.disabled;
      },
      set: function(state) {
        this.channel.codec.vp9.disabled = !state;
      }
    },
    h264State: {
      get: function() {
        return !this.channel.codec.h264.disabled;
      },
      set: function(state) {
        this.channel.codec.h264.disabled = !state;
      }
    },
    validationError: function () {
      return this.$v.channel.codec.$anyError;
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateChannel: function(input){
      input.$touch();
      if (input.$error){
        this.$store.commit("pushError", "Positive values are required.");
      }
    }
  },
  watch: {
    validationError(val) {
      this.$emit("validationErrorChanged", this, val);
    }
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1117px) {
  h4.title{
    display: inline-flex;
  }
  .contextual-help {
    display: inline-flex;
    float: right;
    margin-top: 21px;
  }
  /deep/ .contextual-help > a {
    padding-top: 2px;
  }
}
</style>